import { device } from '@accedo/xdk-core'

export class WebosSettings implements DeviceSettings {
  public init() {}

  public getCaptionState() {
    return new Promise((resolve) => {
      window?.webOS?.service?.request('luna://com.webos.settingsservice', {
        method: 'getSystemSettings',
        parameters: {
          category: 'caption',
          keys: ['captionEnable'],
        },
        onSuccess: function (inResponse) {
          console.log('Caption Result: ' + JSON.stringify(inResponse))
          try {
            resolve(inResponse.settings.captionEnable === 'on')
          } catch {
            resolve(false)
          }
        },
        onFailure: function (inError) {
          console.log('Failed to get settings value')
          console.log('[' + inError.errorCode + ']: ' + inError.errorText)
          resolve(false)
        },
      })
    })
  }

  public addCaptionChangeEventListener(cb) {
    return new Promise((resolve) => {
      let handle = window?.webOS?.service?.request('luna://com.webos.settingsservice', {
        method: 'getSystemSettings',
        parameters: {
          category: 'caption',
          keys: ['captionEnable'],
          subscribe: true,
        },
        onSuccess: function (inResponse) {
          if (typeof inResponse.subscribed != 'undefined') {
            if (!inResponse.subscribed) {
              console.log('Failed to subscribe settings value')
              resolve(null)
            } else {
              resolve(handle)
            }
          }

          cb(inResponse.settings.captionEnable === 'on')
        },
        onFailure: function (inError) {
          console.log('Failed to get settings value')
          console.log('[' + inError.errorCode + ']: ' + inError.errorText)
          resolve(null)
        },
      })
    })
  }

  public removeCaptionChangeEventListener() {}

  public getVoiceState() {
    return new Promise((resolve) => {
      window?.webOS?.service?.request('luna://com.webos.settingsservice', {
        method: 'getSystemSettings',
        parameters: {
          category: 'option',
          keys: ['audioGuidance'],
        },
        onSuccess: function (inResponse) {
          console.log('Audio Result: ' + JSON.stringify(inResponse))
          try {
            resolve(inResponse.settings.audioGuidance === 'on')
          } catch {
            resolve(false)
          }
        },
        onFailure: function (inError) {
          console.error('Error trying to get voice state on device')
          console.log('[' + inError.errorCode + ']: ' + inError.errorText)
          resolve(false)
        },
      })
    })
  }

  public addVoiceChangeEventListener(cb) {
    return new Promise((resolve) => {
      let handle = window?.webOS?.service?.request('luna://com.webos.settingsservice', {
        method: 'getSystemSettings',
        parameters: {
          category: 'option',
          keys: ['audioGuidance'],
          subscribe: true,
        },
        onSuccess: function (inResponse) {
          if (typeof inResponse.subscribed != 'undefined') {
            if (!inResponse.subscribed) {
              console.log('Failed to subscribe settings value')
              resolve(null)
            } else {
              resolve(handle)
            }
          }

          cb(inResponse.settings.audioGuidance === 'on')
        },
        onFailure: function (inError) {
          console.log('Failed to get settings value')
          console.log('[' + inError.errorCode + ']: ' + inError.errorText)
          resolve(null)
        },
      })
    })
  }

  public removeVoiceChangeEventListener() {}

  public async getModel(): Promise<DeviceModel> {
    let model = {
      id: null,
      name: 'WebOS',
      type: 'TV',
      version: null,
    }

    try {
      model = {
        ...model,
        id: await device.system.getUniqueId(),
        name: device.system.getModel(),
        version: device.system.getFirmwareVersion(),
        type: device.system.getDeviceType(),
      }
    } catch (e) {
      console.error('There was a problem capturing the model context data. Details:', e)
    }

    return model
  }

  public getOS(): DeviceOS {
    let os = {
      name: '',
      version: '',
    }

    try {
      os = {
        name: 'webOS',
        version: device.system.getSdkVersion(),
      }
    } catch (e) {
      console.error('There was a problem capturing the os context data. Details:', e)
    }

    return os
  }

  public getVendor(): string {
    return 'LG'
  }

  public getAppStoreURL(): string {
    return 'placeholder'
  }

  public getAppIDForAds(): string {
    return 'placeholder'
  }

  public getRDID(): string {
    //TODO
    return 'placeholder'
  }

  public isLATEnabled(): boolean {
    //TODO
    return true
  }
}
